import * as React from "react"
import type { SVGProps } from "react"
const SvgOutbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 10.14v3.15q0 .42.29.71.29.3.71.29c.42-.01.52-.1.71-.29a1 1 0 0 0 .29-.71v-3.15l.88.87q.14.15.33.23t.38.06q.18 0 .37-.09a1 1 0 0 0 .34-.22q.27-.3.29-.7a1 1 0 0 0-.29-.7l-2.6-2.6a1 1 0 0 0-.32-.21A1 1 0 0 0 12 6.7q-.2 0-.37.07a1 1 0 0 0-.33.2l-2.6 2.6a1 1 0 0 0-.3.72q0 .2.08.36.06.18.22.33.3.3.71.31a1 1 0 0 0 .71-.29zM5 21.71q-.82 0-1.41-.58A2 2 0 0 1 3 19.7v-14q0-.83.59-1.4A2 2 0 0 1 5 3.7h14q.83 0 1.41.6.6.57.59 1.4v14q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h14v-3h-3a5 5 0 0 1-1.79 1.48 4.8 4.8 0 0 1-4.42 0A5 5 0 0 1 8 16.7H5zm7-3q.8 0 1.48-.4.66-.42 1.1-1.1.15-.22.37-.36a1 1 0 0 1 .5-.14H19v-9H5v9h3.55a1 1 0 0 1 .5.14q.23.14.38.36.42.68 1.1 1.1.67.4 1.47.4" />
  </svg>
)
export default SvgOutbox
